import { render, staticRenderFns } from "./NewOrderAlert.vue?vue&type=template&id=39268754&scoped=true&"
import script from "./NewOrderAlert.vue?vue&type=script&lang=js&"
export * from "./NewOrderAlert.vue?vue&type=script&lang=js&"
import style0 from "./NewOrderAlert.vue?vue&type=style&index=0&id=39268754&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "39268754",
  null
  
)

export default component.exports